import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Импорты переводов
import ruTranslations from './locales/ru.json';
import deTranslations from './locales/de.json';

const resources = {
  ru: {
    translation: ruTranslations
  },
  de: {
    translation: deTranslations
  }
};

// Добавляем версию для принудительного обновления кэша
const version = Date.now();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de', // Немецкий как основной язык
    debug: true,
    
    detection: {
      order: ['path', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupFromPathIndex: 0,
    },

    interpolation: {
      escapeValue: false, // React уже делает экранирование
    },

    react: {
      useSuspense: false, // Отключаем Suspense для совместимости
    }
  });

export default i18n;
